import React from 'react';
import ReactDOM from 'react-dom';
import './image_upload.less';
import fileUploadActions from './file_upload_actions';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

class ImageUpload extends React.Component{
  constructor(props){
    super(props);
    this.getFileObject = this.getFileObject.bind(this);
    this.state={
      isLoading: ''
    }
  }

  getFileObject(){
    const {props, state} = this;
    let imageUrl = null;
    // here the function should return the image object
    let file = this.refs.imageUpload.files[0];
    this.setState({
      isLoading: true
    })
    fileUploadActions.shipmentImageUpload(file).then((successData)=> {
      this.setState({
        isLoading: false
      })
      if(successData){
        imageUrl = successData.successMessage;
      }
      this.props.getImageUrlCallback(imageUrl);

    }, (error)=>{
      this.setState({
        isLoading: false
      })
      console.log("error" + error);
    })

  }

  render(){
    const self = this;
    const {props, state} = this;
    let title = "Select a photo of your package"
    if(props.title)
      title = props.title
    return(
      <div className="upload-photo-component">
        <div className="upload-photo-wrap">
          <div className="upload-photo-text-elm">{title}</div>
          <div className={props.title ? "upload-photo-img-wrap" : "upload-photo-img-wrap border"}>
            <div className="file-upload-component-wrap">
              {
                !props.title && <div className="icon-icn_landscape"></div>
              }
              <div className="btn orange upload-btn">
                Upload Photo
                <input className="file-upload-input" type="file" accept="image/*" ref="imageUpload" onChange={this.getFileObject} />
              </div>
            </div>
          </div>
        </div>
        {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
      </div>
    );
  }
}

ImageUpload = connect((state) => {
  return {
  }
}, (dispatch) =>{
    return{
      fileUploadActions: bindActionCreators(fileUploadActions, dispatch)
    }
})(ImageUpload);

ImageUpload.propTypes = {
   getImageUrlCallback: React.PropTypes.func.isRequired
}

export default ImageUpload;

// getImageUrlCallback - is the call back function
//  getImageUrl(imageUrl){
//    console.log(imageUrl)
//  }



// WEBPACK FOOTER //
// app/image_upload/image_upload.jsx